module.exports = __webpack_public_path__ + "img/event-view-013.281ae599.png";